module.exports = __webpack_public_path__ + "static/img/140_TO8_1839_og.9e66f8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/140_TO8_1839_og.jpg
// module id = Zgs/
// module chunks = 0